(function () {
    'use strict';
    angular
        .module('AutoPrequal')
        //GA Events && GA Pageview
        .run(['$rootScope', '$transitions', function ($rootScope, $transitions) {
            function getUrlParameter(sParam) {
                var sPageURL = decodeURIComponent(window.location.search.substring(1)),
                    sURLVariables = sPageURL.split('&'),
                    sParameterName,
                    i;

                for (i = 0; i < sURLVariables.length; i++) {
                    sParameterName = sURLVariables[i].split('=');
                    if (sParameterName[0] === sParam) {
                        return sParameterName[1] === undefined
                            ? true
                            : sParameterName[1];
                    }
                }
            };

			$rootScope.ga = {
                updateIRSlider: function () {
					gaEvent('Click', 'Results - Update Interest Rate')
				},
				updateLTSlider: function () {
					gaEvent('Click', 'Results - Update Loan Term')
				},
				updateMPSlider: function () {
					gaEvent('Click', 'Results - Update Monthly Payments')
				},
                updateDPSlider: function () {
					gaEvent('Click', 'Results - Update Down Payment')
				},
				makingPaymentsYes: function () {
					gaEvent('Click', 'Trade In Loan Payments - Yes, know balance')
				},
				makingPaymentsUnsure: function () {
					gaEvent('Click', "Trade In Loan Payments - Yes but don't know balance")
				},
				makingPaymentsNo: function () {
					gaEvent('Click', 'Trade In Loan Payments - No')
				},
				submitSuccess: function () {
					gaEvent('Submit', 'Results - Success')
				},
                oowErrors: {
                    idNotFound: function () {
						gaEvent("Error", "IDV Failure - >1 Fail in 48 Hours");
                    },
                    idNotFound2: function () {
						gaEvent("Error", "IDV Failure - <2 Fails in 48 Hours");
                    },
                    tuServerfail: function (errorCode) {
						gaEvent("Error", "TransUnion - " + errorCode);
                    }
                },
				serviceErr: function (errCode, desc) { gaEvent("error", "error - " + errCode + "/" + desc) },
				errors: {
					ageOfMajority: function () {
						gaEvent("Error", "Birthdate - Under Age of Majority");
					},
					annualIncome: function(){
						gaEvent("Error", "Annual Income - Less Than $10000");
					},
					submitError: function () {
						gaEvent("Submit", "Results - Decline");
					},
					timeout: function () {
						gaEvent("Error", "Timeout - Website");
					},
					tuError: function (errorCode) {
						gaEvent("Error", "TransUnion - " + errorCode);
					},
					blackbookError: function (errorCode) {
						gaEvent("Error", "CBB - " + errorCode);
					},
					descisionError: function (errorCode) {
						gaEvent("Error", "RBC Decision Engine - " + errorCode);
					},
                    sessionError: function (errCode, desc) {
						gaEvent("Error", "service-error-session - " + errCode + "/" + desc);
                    }
                }
            };
           
            $rootScope.gaCustEvent = {
                tuEndresultSuccess: function () {
                    gaCustEvent('auto-maat-tool-243', 'Quebec Freeze', 'Everyone else coming through')
                },
                tuEndresultFreezeSuccess: function () {
                    gaCustEvent('auto-maat-tool-232', 'Quebec Freeze', 'Exempt - Data with Freeze - Success')
                },
                oowQFreezeFailure: function () {
                    gaCustEvent('auto-maat-tool-230', 'Quebec Freeze', 'Non-Exempt - No Data with Freeze - Error')
                },
                //tuEndresultFailure: function () {
                //    gaCustEvent('auto-maat-tool-2323', 'Quebec Freeze', 'Error - End Results')
                //},
              
            };

            var gaEvent = function (action, label, category) {
                gaEventPush(action, label, category);
            }
            $rootScope.gaEvent = gaEvent;

            var gaEventPush = function (action, label, category) {
                if (!$rootScope.isLoaded && action !== 'Error') return; //ensure session is valid before firing events
                var event = {
					"event": "publicAutoCustEvent",
                    "category": category || "Auto Finance - Prequal",
                    "action": action,
                    "label": label
                }
                dataLayer.push(event);
                if (getUrlParameter('debug') === '1') {
                    console.debug(event, dataLayer);
                }
            }
           
            var gaCustEvent = function (id, action, label, category) {
                if (!$rootScope.isLoaded && action !== 'Error') return; //ensure session is valid before firing events
                var event = {
                    "event": "publicAutoCustEvent",
                    "data-dig-id": id,
                    "category": category || "Auto Finance - Prequal",
                    "action": action,
                    "label": label
                }
                dataLayer.push(event);
                if (getUrlParameter('debug') === '1') {
                    console.debug(event, dataLayer);
                }
            }



            var gaPageView = function (vpvPageName, vpvUrl) {
                if (!$rootScope.isLoaded) return; //ensure session is valid before firing events

                vpvPageName = "Auto Finance - Prequal - " + vpvPageName;
                vpvUrl = "/vpv/autofinance/autoprequal/" + vpvUrl;

                var pageView = {
					"event": "publicAutoPageview",
                    "vpvName": vpvPageName,
                    "vpvURL": vpvUrl,
                    "language": $rootScope.lang.toUpperCase(),
                    "pageType": "Tool"
                };
                dataLayer.push(pageView);
                if (getUrlParameter('debug') === '1') {
                    console.debug('pageView', pageView, dataLayer);
                }
            }
            $rootScope.gaPageView = {
				"oow": function () { gaPageView("Out of Wallet", "out-of-wallet") }
            }

            $transitions.onSuccess({}, function ($transition) {
                //listen to state change to handle gtm page view
                if (!$transition.$to()) return;
                switch ($transition.$to().name) {
                    case 'main':
                        if (!$transition.params().hash) return;
                        switch ($transition.params().hash) {
                            case 'welcome':
                                gaPageView("Start", "start");
                                break;
                            case 'applicantName':
                                gaPageView("Name", "name");
                                break;
                            case 'applicantContact':
                                gaPageView("Email", "email");
                                break;
                            case 'birthdayMonth':
                                gaPageView("Birthday Month", "birthday-month");
                                break;
                            case 'birthdayDay':
                                gaPageView("Birthday Day", "birthday-day");
                                break;
                            case 'birthdayYear':
                                gaPageView("Birthday Year", "birthday-year");
                                break;
                            case 'applicantAddress':
                                gaPageView("Address", "address");
                                break;
                            case 'applicantIncome':
                                gaPageView("Annual Income", "income");
                                break;
                            case 'applicantMortgage':
                                gaPageView("Rent or Mortgage Payment", "rent-mortgage");
                                break;
                            case 'reviewTerms':
                                gaPageView("Terms and Conditions", "terms");
                                break;
                            case 'tradein':
                                gaPageView("Vehicle Trade-in", "vehicle-trade-in");
                                break;
                            case 'tradeinHelp':
                                gaPageView("Help Assess Trade-In Value", "help-assess-trade-in");
                                break;
                            case 'tradeinDetails':
                                gaPageView("Trade-In Info", "trade-in-info");
                                break;
                            case 'tradeinEstimate':
                                gaPageView("Trade-In Estimate", "trade-in-estimate");
                                break;
                            case 'tradeinPayments':
                                gaPageView("Trade-In Loan Payments", "trade-in-loan-payment");
                                break;
                            case 'downPayment':
                                gaPageView("Downpayment", "downpayment");
                                break;
                        }
                        break;
                    case 'results':
                        gaPageView("results", "Results");
                        break;
                    case 'error':
                        break;
                    case 'maintenance':
                        break;
                }
            });
        }])
})();

